/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

'use client';

import 'client-only';
import { clsx } from '@accelint/design-foundation/lib/utils';
import {
  Separator,
  type SeparatorProps,
} from 'react-aria-components/Separator';
import styles from './styles.module.css';

/**
 * MenuSeparator - Visual divider between menu items or sections
 *
 * @example
 * ```tsx
 * <MenuItem>Copy</MenuItem>
 * <MenuSeparator />
 * <MenuItem>Delete</MenuItem>
 * ```
 *
 * @param props - SeparatorProps from react-aria-components.
 * @param props.className - Optional CSS class name.
 * @returns The rendered MenuSeparator component.
 */
export function MenuSeparator({ className, ...rest }: SeparatorProps) {
  return <Separator {...rest} className={clsx(styles.separator, className)} />;
}
